<template>
  <div class="share-image" v-if="true">
    <div class="share-image-container">
      <div class="share-image-header">
        <div class="share-image-header-title">
          <p>{{ $t("imageNavigation.share") }}</p>
        </div>
        <div class="share-image-header-actions">
          <img
            src="@/assets/icons/xclose.svg"
            alt="close"
            @click="closeShare"
          />
        </div>
      </div>
      <div class="share-by-email">
        <div class="share-by-email-container">
          <div class="share-by-email-title">
            <label for="email">{{ $t("imageNavigation.emailAddress") }}</label>

            <input
              type="email"
              v-model="email"
              :placeholder="$t('imageNavigation.emailAddress')"
            />
          </div>
        </div>
        <div class="share-by-email-text">
          <label for="message">{{ $t("imageNavigation.attachMessage") }}</label>
          <textarea
            v-model="message"
            :placeholder="$t('imageNavigation.attachMessage')"
          ></textarea>
        </div>
        <div class="share-by-email-button">
          <button @click="shareByEmail">
            {{ $t("imageNavigation.share") }}
          </button>
        </div>
      </div>
    </div>

    <div class="share-by-link">
      <div class="share-by-link-title">
        <p>{{ $t("imageNavigation.copyLink") }}</p>
        <p>({{ $t("imageNavigation.linkAccess") }})</p>
      </div>
      <div class="copy-link-button">
        <button @click="copyLink">
          {{ $t("imageNavigation.copyLinkButton") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import API from "@/api/API";
import { ElMessage } from "element-plus";

const emit = defineEmits(["closeShare"]);

const props = defineProps(["image"]);

const email = ref("");
const message = ref("");

function closeShare() {
  emit("closeShare");
}

function copyLink() {
  API.projectFileCategories
    .getProjectFileShareLink(props.image.pk)
    .then((response) => {
      if (response.data && response.data.sharedLink) {
        navigator.clipboard.writeText(response.data.sharedLink);
        ElMessage.success({
          message: "Link copied to clipboard",
        });
      } else {
        ElMessage.error({
          message: "Failed to retrieve share link",
        });
      }
    });
}

async function shareByEmail() {
  const data = {
    emailsList: [email.value],
    message: message.value,
  };
  try {
    await API.projectFileCategories.shareProjectFile(data, props.image.pk);
    ElMessage.success({
      message: "Image shared successfully",
    });
    closeShare();
  } catch (error) {
    ElMessage.error({
      message: "Failed to share image",
    });
  }
}
</script>

<style lang="scss" scoped>
.share-image {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 656px;
  height: 569px;
  background-color: #333537;
  color: #fff;
  border-radius: 10px;
  z-index: 10;
  .share-image-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 24px;
    border-bottom: 1px solid #4c4c4c;

    .share-image-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      p {
        font-size: 20px;
        font-weight: 600;
      }
      img {
        cursor: pointer;
      }
    }
    .share-by-email {
      display: flex;
      flex-direction: column;
      align-items: space-between;
      justify-content: center;
      width: 100%;

      .share-by-email-container {
        width: 100%;
        margin: 16px 0;

        .share-by-email-title {
          display: flex;
          flex-direction: column;
          gap: 8px;
          width: 100%;
          align-items: baseline;

          label {
            font-size: 14px;
            color: #fff;
            font-weight: 600;
          }

          input {
            width: 100%;
            padding: 12px;
            border: 1px solid #27292c;
            border-radius: 10px;
            background-color: #27292c;
            color: #fff;
            font-size: 14px;
            outline: none;

            &::placeholder {
              color: rgba(255, 255, 255, 0.5);
            }
          }
        }
      }

      .share-by-email-text {
        width: 100%;
        margin: 16px 0;
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: baseline;

        label {
          font-size: 14px;
          font-weight: 600;
          color: #fff;
        }

        textarea {
          width: 100%;
          padding: 12px;
          border: 1px solid #27292c;
          border-radius: 10px;
          background-color: #27292c;
          color: #fff;
          font-size: 14px;
          outline: none;
          resize: none;
          height: 175px;

          &::placeholder {
            color: rgba(255, 255, 255, 0.5);
          }
        }
      }

      .share-by-email-button {
        width: 100%;

        display: flex;
        justify-content: flex-end;

        button {
          padding: 12px 16px;
          background-color: #23e7a5;
          border: none;
          border-radius: 5px;
          color: #000;
          font-size: 14px;
          cursor: pointer;
          outline: none;
        }
      }
    }
  }
  .share-by-link {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0 24px;
    height: 100%;
    .share-by-link-title {
      display: flex;
      flex-direction: column;
      gap: 8px;
      align-items: baseline;
      p:first-child {
        font-size: 20px;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.87);
      }
      p:last-child {
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.87);
      }
    }
    .copy-link-button {
      button {
        background: none;
        border: none;
        color: #23e7a5;
        font-size: 14px;
        cursor: pointer;
        text-decoration: underline;
        outline: none;
      }
    }
  }
}
</style>
